import React from "react";
import { Helmet } from "react-helmet";
import FooterComponent from "./../../Generic/Footer/FooterComponent";
import HeaderComponent from "./../../Generic/Header/HeaderComponent";
import SeoMeta from "./../../Generic/SEO/SeoMeta";
import ProductListing from "../Catalog/ProductListing";
import { getCategoryMeta, isKnownCategory } from "../Catalog/categoryMeta";
import { getCityLanding, CityLandingLead, CityLandingFaq, cityLandingSchema } from "../Catalog/CityLanding";
import CategoryNotFound from "./CategoryNotFound";
import * as endpoint from "./../../../Service/endpoints";

function CategoryComponent({ match }) {
  // "/delhi/appliances" is the public URL for the API's "appliance" category.
  const category = endpoint.apiCategorySlug(match.params.category);
  const publicSlug = endpoint.publicCategorySlug(category);
  const citySlug = match.params.city || "delhi";
  const cityName = citySlug.charAt(0).toUpperCase() + citySlug.slice(1);

  // A URL like "/delhi/:category" or "/delhi/sofa-rental" is not a catalogue
  // page: show a real not-found page instead of an error state search engines
  // could index.
  if (!isKnownCategory(category)) {
    return <CategoryNotFound citySlug={citySlug} />;
  }
  const meta = getCategoryMeta(category);
  const landing = getCityLanding(citySlug, category);
  const canonical = `https://voorent.com/${citySlug}/${publicSlug}`;

  return (
    <React.Fragment>
      {landing ? (
        <SeoMeta title={landing.title} description={landing.description} canonical={canonical} image={meta.image || "https://voorent.com/logo192.png"} />
      ) : (
        <SeoMeta
          title={`${meta.short} on Rent in ${cityName} | Voorent`}
          description={`Browse ${meta.short.toLowerCase()} on rent in ${cityName}. ${meta.description}`}
          canonical={canonical}
          image={meta.image || "https://voorent.com/logo192.png"}
        />
      )}
      {landing ? (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(cityLandingSchema(landing))}</script>
        </Helmet>
      ) : null}
      <HeaderComponent />
      <ProductListing
        mode="category"
        category={category}
        heading={landing ? landing.h1 : meta.title}
        description={landing ? landing.intro : meta.description}
        className={landing ? "v-listing--landing" : undefined}
        lead={landing ? <CityLandingLead page={landing} /> : null}
        after={landing ? <CityLandingFaq page={landing} /> : null}
        crumbs={[
          { label: "Home", to: endpoint.getPath("") },
          { label: meta.short, to: endpoint.getPath(category) },
        ]}
      />
      <FooterComponent />
    </React.Fragment>
  );
}

export default CategoryComponent;
